import { render, staticRenderFns } from "./NoSubscription.vue?vue&type=template&id=9fedd470"
import script from "./NoSubscription.vue?vue&type=script&lang=js"
export * from "./NoSubscription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports